export enum VersionStatusEnum {
  CREATED = 100,
  UPDATED = 200,
  RESTORED = 210,
  DELETED = 400,
}
